import React, { Fragment } from "react";
import CountUp, { useCountUp } from "react-countup";
import Header2 from "../../components/header/Header2";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import urgencyBg from "../../images/cta/bg-img.png";
import CtaSection from "../../components/CtaSection/CtaSection";
import icon from "../../images/icon/ser-01.svg";
import sImg from "../../images/cta/server2.png";
import sImg2 from "../../images/shape/brd_shape.png";
import DataCenterPricingSection from "./DataCenterPricing";
import DataCenterCalculator from "./DataCenterCalculator";
import DataCenterFaqSection from "./DataCenterFaqSection";
import "../../css/datacenter-offer.css";

// Importando GIFs animados
import shieldGif from "../../images/icon/shield.gif";
import securityGif from "../../images/icon/cloud-security.gif";
import backupGif from "../../images/icon/database.gif";
import supportGif from "../../images/icon/support.gif";
import suport24hourGif from "../../images/icon/24-hour-service.gif";
import fastGif from "../../images/icon/24-hour-service.gif";
import savingsGif from "../../images/icon/savings.gif";
import warningGif from "../../images/icon/warning.gif";

const PricingPage = (props) => {
  useCountUp({
    end: "56656",
    ref: "counter",
    enableScrollSpy: true,
    scrollSpyDelay: 1000,
  });

  return (
    <Fragment>
      <style>
        {`
          .page-title .page-title-wrap,
          .page-title .page-title-box,
          .page-title .sub-title,
          .page-title .title,
          .page-title .hero-cta {
            text-align: left !important;
          }
          .page-title .hero-cta {
            display: flex !important;
            justify-content: flex-start !important;
          }
          @media (max-width: 768px) {
            .page-title .hero-cta {
              text-align: left !important;
              display: flex !important;
              justify-content: flex-start !important;
              flex-direction: column !important;
              align-items: flex-start !important;
            }
            .page-title .hero-cta .cp-btn,
            .page-title .hero-cta .cp-btn-outline {
              display: inline-flex !important;
              width: auto !important;
              margin-right: 15px !important;
              margin-bottom: 10px !important;
            }
          }
        `}
      </style>
      <div className="body_wrap sco_agency">
        <Header2 />
        <section
          className="page-title pt-200 pos-rel bg_img"
          style={{
            backgroundImage: `url(${Bg})`,
            textAlign: "left !important",
          }}
        >
          <div className="container" style={{ textAlign: "left !important" }}>
            <div
              className="page-title-wrap pg-title-wrap"
              style={{ textAlign: "left !important" }}
            >
              <div className="row mt-none-30 align-items-start">
                <div
                  className="col-lg-7 mt-40"
                  style={{ textAlign: "left !important" }}
                >
                  <div
                    className="page-title-box"
                    style={{
                      textAlign: "left !important",
                      display: "block !important",
                      width: "100% !important",
                    }}
                  >
                    <span
                      className="sub-title"
                      style={{
                        textAlign: "left !important",
                        display: "flex !important",
                        alignItems: "center",
                        justifyContent: "flex-start !important",
                      }}
                    >
                      <img src={icon} alt="" style={{ marginRight: "8px" }} />{" "}
                      Cloud VPS Somar
                    </span>
                    <h2
                      className="title"
                      style={{ textAlign: "left !important" }}
                    >
                      Liberdade Total, Velocidade <br /> Máxima e Economia Real{" "}
                      <br />{" "}
                      <span style={{ color: "#0E55DC", fontSize: "0.8em" }}>
                        a partir de R$ 148,90/mês
                      </span>
                    </h2>
                    <div
                      className="hero-cta"
                      style={{
                        marginTop: "30px",
                        textAlign: "left !important",
                        display: "flex",
                        justifyContent: "flex-start !important",
                      }}
                    >
                      <a
                        href="#planos"
                        className="cp-btn"
                        style={{
                          marginRight: "15px",
                          background: "#0E55DC",
                          borderColor: "#0E55DC",
                        }}
                      >
                        Ver Ofertas
                      </a>
                      {/* <a
                        href="#calculadora"
                        className="cp-btn-outline"
                        style={{
                          background:
                            "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
                          border: "2px solid #0E55DC",
                          color: "#0E55DC",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.background =
                            "linear-gradient(135deg, #FFC107 0%, #FFD54F 100%)";
                          e.target.style.color = "#333";
                          e.target.style.borderColor = "#FFC107";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background =
                            "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)";
                          e.target.style.color = "#0E55DC";
                          e.target.style.borderColor = "#0E55DC";
                        }}
                      >
                        Calcular Preço
                      </a> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 mt-40">
                  <div
                    className="pg-img-right pos-rel"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      minHeight: "400px",
                    }}
                  >
                    <img
                      src={sImg}
                      alt="Cloud VPS"
                      style={{
                        width: "100%",
                        height: "700px",
                        maxWidth: "750px",
                        objectFit: "contain",
                        transform: "scale(1.2)",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="fanfact pg-fan-bg pt-100 pb-125">
          <div className="container">
            <div className="pg-fanfact-wrap ul_li_between mt-none-30">
              <div className="ap-fanfact-item pg-fanfact-item mt-30">
                <h2 className="xb-item--number">100%</h2>
                <span className="xb-item--text">Controle Total</span>
                <p className="xb-item--content">
                  Autonomia completa para gerenciar sua VPS sem limitações ou
                  interferências.
                </p>
              </div>
              <div className="ap-fanfact-item pg-fanfact-item mt-30">
                <h2 className="xb-item--number">
                  <CountUp end={60} enableScrollSpy />
                  min
                </h2>
                <span className="xb-item--text">Provisionamento Rápido</span>
                <p className="xb-item--content">
                  Sua máquina virtual com IP dedicado pronta para uso em
                  minutos.
                </p>
              </div>
              <div className="ap-fanfact-item pg-fanfact-item mt-30">
                <h2 className="xb-item--number">IP</h2>
                <span className="xb-item--text">Dedicado Incluso</span>
                <p className="xb-item--content">
                  Conectividade direta e estável sem NAT ou restrições de rede.
                </p>
              </div>
            </div>
          </div>
          <span id="counter" className="d-none" />
        </section>

        <DataCenterPricingSection />

        {/* Seção de Testimoniais */}
        <section
          className="testimonials-section pt-100 pb-100"
          style={{ background: "white" }}
        >
          <div className="container">
            <div className="text-center mb-60">
              <h2 className="title">O que nossos clientes dizem</h2>
              <p style={{ color: "#666", fontSize: "18px", marginTop: "20px" }}>
                Mais de 500 empresas já confiam em nossa infraestrutura
              </p>
            </div>
            <div className="row">
              <div className="col-lg-4 mb-30">
                <div
                  className="testimonial-item"
                  style={{
                    background: "#f8f9fa",
                    padding: "30px",
                    borderRadius: "10px",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      fontSize: "48px",
                      color: "#0E55DC",
                      marginBottom: "20px",
                    }}
                  >
                    "
                  </div>
                  <p
                    style={{
                      color: "#333",
                      fontSize: "16px",
                      marginBottom: "25px",
                      fontStyle: "italic",
                    }}
                  >
                    "A liberdade de configurar tudo do meu jeito, sem camadas de
                    gestão desnecessárias, fez toda diferença. O provisionamento
                    é rápido e o custo-benefício imbatível."
                  </p>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                      <h5 style={{ color: "#333", margin: "0" }}>
                        Carlos Mendes
                      </h5>
                      <span style={{ color: "#666", fontSize: "14px" }}>
                        DevOps Engineer - TechSolutions
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-30">
                <div
                  className="testimonial-item"
                  style={{
                    background: "#f8f9fa",
                    padding: "30px",
                    borderRadius: "10px",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      fontSize: "48px",
                      color: "#0E55DC",
                      marginBottom: "20px",
                    }}
                  >
                    "
                  </div>
                  <p
                    style={{
                      color: "#333",
                      fontSize: "16px",
                      marginBottom: "25px",
                      fontStyle: "italic",
                    }}
                  >
                    "IP dedicado, datacenter nacional e total autonomia para
                    administrar como quero. É exatamente o que precisávamos para
                    nossos projetos sem complicação."
                  </p>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                      <h5 style={{ color: "#333", margin: "0" }}>
                        Marina Santos
                      </h5>
                      <span style={{ color: "#666", fontSize: "14px" }}>
                        Tech Lead - Digital Agency Pro
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-30">
                <div
                  className="testimonial-item"
                  style={{
                    background: "#f8f9fa",
                    padding: "30px",
                    borderRadius: "10px",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      fontSize: "48px",
                      color: "#0E55DC",
                      marginBottom: "20px",
                    }}
                  >
                    "
                  </div>
                  <p
                    style={{
                      color: "#333",
                      fontSize: "16px",
                      marginBottom: "25px",
                      fontStyle: "italic",
                    }}
                  >
                    "Pago apenas pela infraestrutura que preciso, sem extras
                    desnecessários. Velocidade nacional, preço justo e suporte
                    quando necessário. Perfeito!"
                  </p>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                      <h5 style={{ color: "#333", margin: "0" }}>
                        Roberto Silva
                      </h5>
                      <span style={{ color: "#666", fontSize: "14px" }}>
                        Founder - StartupDev Brasil
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <DataCenterCalculator /> */}

        {/* Seção de Urgência */}
        <section
          className="urgency-section pt-80 pb-80"
          style={{
            backgroundImage: `url(${urgencyBg})`,
            color: "white",
          }}
        >
          <div className="container text-center">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h2
                  style={{
                    color: "white",
                    marginBottom: "20px",
                    fontSize: "32px",
                  }}
                >
                  Comece Agora com Total Liberdade!
                </h2>
                <p
                  style={{
                    fontSize: "20px",
                    marginBottom: "30px",
                    opacity: "0.9",
                  }}
                >
                  Contrate seu <strong>Cloud VPS Somar</strong> e tenha acesso a{" "}
                  <br />
                  Autonomia completa, infraestrutura nacional e preço justo!
                </p>
                <div
                  style={{
                    background: "rgba(255,255,255,0.1)",
                    padding: "20px",
                    borderRadius: "10px",
                    marginBottom: "30px",
                  }}
                >
                  <div style={{ fontSize: "18px", marginBottom: "10px" }}>
                    Deploy em:
                  </div>
                  <div style={{ fontSize: "36px", fontWeight: "bold" }}>
                    60 min
                  </div>
                </div>
                <a
                  href="#planos"
                  className="cp-btn"
                  style={{
                    background: "#FFC107",
                    color: "white",
                    border: "2px solid white",
                    padding: "18px 40px",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  Contratar Cloud VPS Agora
                </a>
              </div>
            </div>
          </div>
        </section>

        <DataCenterFaqSection />

        {/* Seção de Garantias */}
        <section
          className="guarantees-final pt-100 pb-100"
          style={{ background: "#f8f9fa" }}
        >
          <div className="container">
            <div className="text-center mb-60">
              <h2 className="title">Destaques do Cloud VPS Somar</h2>
              <p style={{ color: "#666", fontSize: "18px", marginTop: "20px" }}>
                Ideal para desenvolvedores, agências, integradores e projetos
                que exigem liberdade técnica com custo otimizado
              </p>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 mb-40">
                <div
                  className="guarantee-card"
                  style={{
                    background: "white",
                    padding: "40px 30px",
                    borderRadius: "15px",
                    textAlign: "center",
                    height: "100%",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <div>
                    <img
                      src={fastGif}
                      alt="Provisionamento rápido"
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                  <h4 style={{ color: "#333", marginBottom: "15px" }}>
                    Provisionamento Rápido
                  </h4>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "14px",
                      lineHeight: "1.6",
                    }}
                  >
                    Sua VPS pronta para uso em poucos minutos, com acesso
                    imediato e total controle.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-40">
                <div
                  className="guarantee-card"
                  style={{
                    background: "white",
                    padding: "40px 30px",
                    borderRadius: "15px",
                    textAlign: "center",
                    height: "100%",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <div>
                    <img
                      src={shieldGif}
                      alt="Autonomia"
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                  <h4 style={{ color: "#333", marginBottom: "15px" }}>
                    Autonomia Completa
                  </h4>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "14px",
                      lineHeight: "1.6",
                    }}
                  >
                    Você gerencia tudo, sem limitações ou interferências.
                    Controle total sobre sua VM.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-40">
                <div
                  className="guarantee-card"
                  style={{
                    background: "white",
                    padding: "40px 30px",
                    borderRadius: "15px",
                    textAlign: "center",
                    height: "100%",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <div>
                    <img
                      src={securityGif}
                      alt="IP Dedicado"
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                  <h4 style={{ color: "#333", marginBottom: "15px" }}>
                    IP Dedicado Incluso
                  </h4>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "14px",
                      lineHeight: "1.6",
                    }}
                  >
                    Conectividade direta, sem NAT ou restrições. IP público
                    exclusivo para sua VM.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-40">
                <div
                  className="guarantee-card"
                  style={{
                    background: "white",
                    padding: "40px 30px",
                    borderRadius: "15px",
                    textAlign: "center",
                    height: "100%",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <div>
                    <img
                      src={suport24hourGif}
                      alt="Suporte"
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                  <h4 style={{ color: "#333", marginBottom: "15px" }}>
                    Suporte 24/7 em Português
                  </h4>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "14px",
                      lineHeight: "1.6",
                    }}
                  >
                    Foco em infraestrutura, sempre disponível. Suporte técnico
                    especializado 24 horas.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-40">
                <div
                  className="guarantee-card"
                  style={{
                    background: "white",
                    padding: "40px 30px",
                    borderRadius: "15px",
                    textAlign: "center",
                    height: "100%",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <div>
                    <img
                      src={shieldGif}
                      alt="Infraestrutura"
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                  <h4 style={{ color: "#333", marginBottom: "15px" }}>
                    Infraestrutura Nacional
                  </h4>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "14px",
                      lineHeight: "1.6",
                    }}
                  >
                    Menor latência e mais estabilidade. Datacenter Tier III no
                    Brasil.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-40">
                <div
                  className="guarantee-card"
                  style={{
                    background: "white",
                    padding: "40px 30px",
                    borderRadius: "15px",
                    textAlign: "center",
                    height: "100%",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <div>
                    <img
                      src={savingsGif}
                      alt="Economia"
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                  <h4 style={{ color: "#333", marginBottom: "15px" }}>
                    Economia Real
                  </h4>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "14px",
                      lineHeight: "1.6",
                    }}
                  >
                    Preço justo, sem extras desnecessários. Pague em reias.
                  </p>
                </div>
              </div>
            </div>

            {/* Certificações */}
            <div className="certifications mt-60">
              <div className="text-center mb-40">
                <h3 style={{ color: "#333", marginBottom: "20px" }}>
                  Proteções do Datacenter
                </h3>
              </div>
              <div className="row justify-content-center">
                <div className="col-lg-2 col-md-3 col-sm-4 col-6 mb-30">
                  <div
                    className="cert-item"
                    style={{
                      background: "white",
                      padding: "20px",
                      borderRadius: "10px",
                      textAlign: "center",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <div style={{ fontSize: "32px", marginBottom: "10px" }}>
                      ISO
                    </div>
                    <p
                      style={{
                        margin: "0",
                        fontSize: "12px",
                        color: "#666",
                        fontWeight: "bold",
                      }}
                    >
                      ISO 27001
                    </p>
                  </div>
                </div>
                <div className="col-lg-2 col-md-3 col-sm-4 col-6 mb-30">
                  <div
                    className="cert-item"
                    style={{
                      background: "white",
                      padding: "20px",
                      borderRadius: "10px",
                      textAlign: "center",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <div style={{ fontSize: "32px", marginBottom: "10px" }}>
                      SOC
                    </div>
                    <p
                      style={{
                        margin: "0",
                        fontSize: "12px",
                        color: "#666",
                        fontWeight: "bold",
                      }}
                    >
                      SOC 2
                    </p>
                  </div>
                </div>
                <div className="col-lg-2 col-md-3 col-sm-4 col-6 mb-30">
                  <div
                    className="cert-item"
                    style={{
                      background: "white",
                      padding: "20px",
                      borderRadius: "10px",
                      textAlign: "center",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <div style={{ fontSize: "32px", marginBottom: "10px" }}>
                      LGPD
                    </div>
                    <p
                      style={{
                        margin: "0",
                        fontSize: "12px",
                        color: "#666",
                        fontWeight: "bold",
                      }}
                    >
                      LGPD
                    </p>
                  </div>
                </div>
                <div className="col-lg-2 col-md-3 col-sm-4 col-6 mb-30">
                  <div
                    className="cert-item"
                    style={{
                      background: "white",
                      padding: "20px",
                      borderRadius: "10px",
                      textAlign: "center",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <div style={{ fontSize: "32px", marginBottom: "10px" }}>
                      TIER
                    </div>
                    <p
                      style={{
                        margin: "0",
                        fontSize: "12px",
                        color: "#666",
                        fontWeight: "bold",
                      }}
                    >
                      Tier III
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default PricingPage;
